import * as React from "react";
import { Formik } from "formik";
import * as Yup from "yup";

import { CandidateAddEditInterviewDialogProps } from "./candidateInterviewProps";
import { CandidateInterviewFormData } from "./types";
import { CandidateInterview } from "./candidateInterview";

export const CandidateAddEditInterviewDialog = (
    props: CandidateAddEditInterviewDialogProps
) => {
    const { candidateInterview } = props;

    return (
        <Formik
            name="interviewForm"
            initialValues={CandidateInterviewFormData.create(
                candidateInterview
            )}
            onSubmit={() => {
                /* noop */
            }}
            validateOnBlur={false}
            validateOnChange={true}
            validationSchema={validationSchema}
        >
            <CandidateInterview {...props} />
        </Formik>
    );
};

const validationSchema = Yup.object().shape(
    {
        interviewStatusTypeId: Yup.number()
            .required("interview status is required")
            .nullable(true),
        interviewDate: Yup.date()
            .required("date is required")
            .typeError("invalid date")
            .nullable(true),
        interviewTime: Yup.string()
            .required("time is required")
            .typeError("invalid time")
            .nullable(true),
        durationHours: Yup.number()
            .when("durationMinutes", {
                is: val => val === 0,
                then: Yup.number().min(
                    1,
                    "both hours and minutes may not be zero"
                ),
                otherwise: Yup.number().min(0),
            })

            .required("duration is required")
            .typeError("invalid duration")
            .max(7, "max allowed value is 7 hours")
            // .min(0, "select a positive number")
            .nullable(true),
        durationMinutes: Yup.number()
            .when("durationHours", {
                is: val => val === 0,
                then: Yup.number().min(
                    15,
                    "both hours and minutes may not be zero"
                ),
                otherwise: Yup.number().min(0),
            })
            .typeError("invalid duration")
            .max(45, "max allowed value is 45 minutes")
            // .min(0, "select a positive number")
            .test({
                name: "allowedValue",
                message: "allowed values 0, 15, 30 or 45 minutes",
                test: value => value % 15 === 0,
            })
            .nullable(true),
        timeZoneId: Yup.number()
            .required("timezone is required")
            .nullable(true),
        interviewTypeId: Yup.number()
            .required("interview type is required")
            .nullable(true),
    },
    [["durationMinutes", "durationHours"]]
);
